import { render, staticRenderFns } from "./ListSamples.vue?vue&type=template&id=ed6ee32e"
import script from "./ListSamples.vue?vue&type=script&lang=js"
export * from "./ListSamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports